// extracted by mini-css-extract-plugin
export var container = "_dv-1";
export var cornerButtonContainer = "_dv-6";
export var disabled = "_dv-2";
export var dragActive = "_dv-3";
export var fileContainer = "_dv-5";
export var hiddenInput = "_dv-4";
export var widthContainer = "_dv-0";